import Shop from '@/shop';

/**
 * @private
 * @function
 * @description
 * Получаем время жизни кеша
 * 0 секунд для страницы заказов
 * 3 секунды для админки
 * 60 секунд для страницы товара
 * 120 секунд для всех остальных страниц
 *
 * @return {Number} - время жизни кеша в секундах
 */
export default function() {
  const MILISECOND = 1000;
  const isPageOrders = window.location.pathname.indexOf('/orders/') === 0;
  const isProductPage = Shop.config.page_config.product_id;
  const isAdmin = document.querySelector('#insales-panel');

  let SECOND = MILISECOND * 120 * 1;
  if (isAdmin) {
    SECOND = MILISECOND * 3 * 1;
  } else if (isProductPage) {
    SECOND = MILISECOND * 60 * 1;
  } else if (isPageOrders) {
    SECOND = 0;
  }

  return SECOND;
}
